var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tree-list',{ref:"list",on:{"load":_vm.load,"add":_vm.add}}),_c('tree-composer',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_composer),expression:"show_composer"}],ref:"composer",staticStyle:{"margin-top":"15px"},on:{"updated":_vm.updated,"deleted":_vm.deleted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }